var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5002 16.6666C10.0418 16.6666 9.64961 16.5035 9.3235 16.1774C8.99683 15.8508 8.8335 15.4583 8.8335 14.9999C8.8335 14.5416 8.99683 14.1491 9.3235 13.8224C9.64961 13.4963 10.0418 13.3333 10.5002 13.3333C10.9585 13.3333 11.351 13.4963 11.6777 13.8224C12.0038 14.1491 12.1668 14.5416 12.1668 14.9999C12.1668 15.4583 12.0038 15.8508 11.6777 16.1774C11.351 16.5035 10.9585 16.6666 10.5002 16.6666ZM10.5002 11.6666C10.0418 11.6666 9.64961 11.5033 9.3235 11.1766C8.99683 10.8505 8.8335 10.4583 8.8335 9.99992C8.8335 9.54158 8.99683 9.14909 9.3235 8.82242C9.64961 8.49631 10.0418 8.33325 10.5002 8.33325C10.9585 8.33325 11.351 8.49631 11.6777 8.82242C12.0038 9.14909 12.1668 9.54158 12.1668 9.99992C12.1668 10.4583 12.0038 10.8505 11.6777 11.1766C11.351 11.5033 10.9585 11.6666 10.5002 11.6666ZM10.5002 6.66659C10.0418 6.66659 9.64961 6.50325 9.3235 6.17659C8.99683 5.85047 8.8335 5.45825 8.8335 4.99992C8.8335 4.54159 8.99683 4.14936 9.3235 3.82325C9.64961 3.49659 10.0418 3.33325 10.5002 3.33325C10.9585 3.33325 11.351 3.49659 11.6777 3.82325C12.0038 4.14936 12.1668 4.54159 12.1668 4.99992C12.1668 5.45825 12.0038 5.85047 11.6777 6.17659C11.351 6.50325 10.9585 6.66659 10.5002 6.66659Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.1c736facb515aa97489b98253cf1f54f.svg";
export { ForwardRef as ReactComponent };